<script lang="ts">
    import arrow from 'src/components/cabinet/inventory/arrow.svg'
    import {getUnitsByFilter} from 'src/components/cabinet/#services/inventory'
    import background from 'src/components/main/marketplace/components/nft-cards/background.svg'
    import star from 'src/components/main/marketplace/components/nft-cards/star.svg'
    import plus from 'src/components/main/marketplace/components/nft-cards/plus.svg'
    import metamask from 'src/components/#assets/metamask.svg'
    import {Link} from 'svelte-routing'
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import {userProfile} from 'src/services/auth'

    export let category
    let inventoryContainer
    let currentPage = 0
    $: innerWidth
    let perPage = innerWidth < 1690 || innerWidth >= 1950 ? 24 : 25
    let orderBy = {"column": "updatedAt", "desc": true}
    let filters = [{ "column": "userId", "value": $userProfile.userId }]
    let rarityList = { 0: 'Common', 1: 'Rare', 2: 'Epic', 3: 'Legendary', 4: 'Supreme' }
    let classDropdownOpen = false
    let sortDropdownOpen = false
    let selectedSort = 'Newest'
    let selectedRarity = []

    $: currentPage, orderBy, filters, filter()

    function filter() {
        getUnitsByFilter.send({ data: {
            page: currentPage + 1,
            perPage,
            filters,
            orderBy
        } })
        window.scrollTo(0, inventoryContainer?.offsetTop)
    }

    function changeSort(param) {
        sortDropdownOpen = false
        switch (param) {
            case "rarity":
                selectedSort = "Rarity"
                orderBy = { "column": "rarity", "desc": true }
                break
            case "old":
                selectedSort = "Oldest"
                orderBy = { "column": "updatedAt", "desc": false }
                break
            default:
                selectedSort = "Newest"
                orderBy = { "column": "updatedAt", "desc": true }
        }
    }

    function changeRarity(rarity) {
        currentPage = 0
        if (rarity == 'all') {
            selectedRarity = []
        } else {
            if (!selectedRarity.includes(rarity)) {
                selectedRarity = [...selectedRarity, rarity]
            } else {
                selectedRarity = selectedRarity.filter(item => item !== rarity)
            }
        }
        if (selectedRarity.length) {
            filters = [
                { "column": "userId", "value": $userProfile.userId },
                { "column": "rarity", "value": selectedRarity }
            ]
        } else {
            selectedRarity = []
            filters = [{ "column": "userId", "value": $userProfile.userId }]
        }
    }
</script>

<div class="row mb-4">
    <div class="col-md-6">
        <div class="dropdown" use:clickOutside={() => {classDropdownOpen = false}} class:active={classDropdownOpen}>
            <div class="dropdown-selected">
                <div class="need-select" on:click={() => {classDropdownOpen = !classDropdownOpen}}>
                    Choose a rarity<img src="{arrow}" class="arrow" alt="">
                </div>
            </div>
            <div class="dropdown-list">
                <label class="checkbox">
                    <input type="checkbox" on:click={() => changeRarity('all')} checked={!selectedRarity.length}
                       disabled={!selectedRarity.length}>All
                </label>
                <label class="checkbox">
                    <input type="checkbox" on:click={() => changeRarity(0)} checked={selectedRarity.includes(0)}>Common
                </label>
                <label class="checkbox">
                    <input type="checkbox" on:click={() => changeRarity(1)} checked={selectedRarity.includes(1)}>Rare
                </label>
                <label class="checkbox">
                    <input type="checkbox" on:click={() => changeRarity(2)} checked={selectedRarity.includes(2)}>Epic
                </label>
                <label class="checkbox">
                    <input type="checkbox" on:click={() => changeRarity(3)} checked={selectedRarity.includes(3)}>Legendary
                </label>
                <label class="checkbox">
                    <input type="checkbox" on:click={() => changeRarity(4)} checked={selectedRarity.includes(4)}>Supreme
                </label>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="d-flex align-items-center justify-content-end">
            <span class="sort-by">Sort by</span>
            <div class="dropdown sort-by-dropdown"
                 use:clickOutside={() => {sortDropdownOpen = false}}
                 class:active={sortDropdownOpen}>
                <div class="dropdown-selected">
                    <div class="need-select" on:click={() => {sortDropdownOpen = !sortDropdownOpen}}>
                        {selectedSort}<img src="{arrow}" class="arrow" alt="">
                    </div>
                </div>
                <div class="dropdown-list">
                    <div class="item" on:click={() => changeSort('new')}>Newest</div>
                    <div class="item" on:click={() => changeSort('old')}>Oldest</div>
                    <div class="item" on:click={() => changeSort('rarity')}>Rarity</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row inventory-cards">
    {#if !$getUnitsByFilter.hasValue && $getUnitsByFilter.loading}
        <div class="color-white text-center">Loading...</div>
    {:else if !$getUnitsByFilter.hasValue && $getUnitsByFilter.error }
        <div class="color-white text-center">Something went wrong</div>
    {:else if $getUnitsByFilter.value}
        {#each $getUnitsByFilter?.value?.items as {productId, rarity, level, elements, name, image, status, additionalParams }}
            {@const link = productId ? 'inventory/unit/'+productId : '/inventory/units'}
            <Link to="{link}" class="nft-card card-{rarity} {!productId ? 'disabled' : ''}" style="--Background:url({background});">
                <div class="rarity rarity-id-{rarity}">
                    <div class="rarity-value notranslate">{rarityList[rarity]}</div>
                    <div class="level notranslate">
                        <span>{#if productId} LVL.{level} {:else} Minting... {/if}</span>
                    </div>
                    {#if additionalParams?.provider === 'metamask'}
                        <img src="{metamask}" class="provider" alt="{additionalParams.provider}" title="Imported from {additionalParams.provider}">
                    {/if}
                    <div class="image">
                        {#if status === 'inMarket'}
                            <div class="for-sale">On sale</div>
                        {/if}
                        <img src="{image.replace('orig', 'thumb')}" alt="nft">
                    </div>
                    <div class="elements">
                        {#if elements && elements.length}
                            {#each elements as item}
                                {#if item.element}
                                    <img src="/images/elements/{item.element}-{item.subElement}.svg">
                                {/if}
                            {/each}
                        {/if}
                    </div>
                </div>
                <div class="stars">
                    {#each {length: rarity + 2} as _, i}
                        {#if i < 5}
                            <img src="{star}" alt="star">
                        {/if}
                    {/each}
                    {#if rarity === 4}
                        <img src="{plus}" class="plus" alt="plus">
                    {/if}
                </div>
                <div class="name notranslate">{name}</div>
            </Link>
        {:else}
            <div class="no-data">No data yet</div>
        {/each}
    {/if}
</div>
<div class="text-center">
    <Pagination
        bind:currentPage={currentPage}
        totalCount={$getUnitsByFilter?.value?.totalCount}
        {perPage}
        disabled={!$getUnitsByFilter.hasValue && $getUnitsByFilter.loading}/>
</div>

<style>
    .no-data {
        color: #b4c1cf;
        font-size: 18px;
        text-align: center;
    }

    .for-sale {
        position: absolute;
        z-index: 2;
        font-size: 12px;
        line-height: 1;
        color: white;
        background: #FF5D1C;
        padding: 6px 7px;
        border-radius: 5px;
        right: 5px;
        top: 5px;
    }

    .dropdown {
        background: #343168;
        width: 290px;
        border-radius: 3px;
        position: relative;
        z-index: 4;
    }

    .dropdown.sort-by-dropdown {
        width: 180px;
    }

    .dropdown-selected {
        padding: 10px;
        font-size: 14px;
        color: #b8c6d7;
        font-weight: 300;
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 20px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 16px 20px;
        height: 50px;
        margin: -10px;
    }

    .dropdown-list {
        display: none;
        padding: 20px;
        position: absolute;
        background: #343168;
        width: 100%;
        border-radius: 3px;
        margin-top: 10px;
        z-index: 2;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .checkbox,
    .dropdown-list .item {
        font-size: 16px;
        margin-bottom: 10px;
        color: white;
        padding: 5px 0;
        display: block;
        cursor: pointer;
        user-select: none;
        transition: .25s;
    }

    .dropdown-list .checkbox:hover,
    .dropdown-list .item:hover {
        color: #cbcaca;
    }

    .dropdown-list .checkbox:last-child,
    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    .checkbox input[type="checkbox"] {
        width: 1em;
        height: 1em;
        margin-top: 1px;
        vertical-align: top;
        margin-right: 10px;
        background: none;
        border-radius: 2px;
        border: 1px solid #A0AEC0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }

    .checkbox input[type="checkbox"]:checked {
        background-color: #FF5D1C;
        border-color: #FF5D1C;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
    }

    .sort-by {
        font-size: 14px;
        color: #a0aec0;
        padding-right: 20px;
    }

    .elements {
        width: 100%;
        height: 40px;
        text-align: right;
        margin: -20px 0 0;
        position: relative;
        z-index: 2;
        padding-right: 5px;
        display: flex;
        justify-content: flex-end;
    }

    .elements img {
        width: 35px;
        height: 35px;
    }

    .elements img:not(:first-child) {
        margin-left: -10px;
    }

    .provider {
        width: 32px;
        position: absolute;
        margin: 5px;
        z-index: 3;
    }

    .rarity {
        margin: 5px;
        position: relative;
        overflow: hidden;
    }

    .rarity:before {
        content: "";
        border-radius: 8px;
        width: 100%;
        height: calc(100% - 30px);
        position: absolute;
        background: #61758a;
        left: 0;
        top: 0;
    }

    .rarity-value {
        padding: 10px 15px;
        position: relative;
        color: white;
        font-size: 13px;
        font-weight: 500;
        line-height: 1;
        height: 33px;
    }

    .inventory-cards {
        margin: 50px 0 26px;
    }

    .inventory-cards :global(.nft-card) {
        width: 230px;
        margin: 0 30px 30px 0;
        border-radius: 10px;
        background: #26244D;
        border: 2px solid #494591;
        display: block;
        text-decoration: none;
        position: relative;
        padding: 0;
        transition: .25s;
        overflow: hidden;
        cursor: pointer;
    }

    .image {
        background: linear-gradient(180deg, #3E2929 -72.66%, #0B0E21 132.58%);
        height: 205px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-bottom: 18px;
    }

    .level {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 15px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 1;
        padding: 9px 15px 0 0;
        text-align: right;
        width: 50%;
        height: 33px;
    }

    .level:before {
        content: "";
        width: 100%;
        height: 50px;
        background: #26244D;
        left: 0;
        right: 0;
        top: 0;
        position: absolute;
    }

    .level:after {
        content: "";
        width: 50px;
        height: 70px;
        background: #26244D;
        left: -12px;
        right: 0;
        top: -20px;
        position: absolute;
        transform: rotate(-20deg);
    }

    .level span {
        color: white;
        position: relative;
        z-index: 2;
    }

    .stars {
        padding: 0 13px 6px;
        margin-top: -15px;
    }

    .image img {
        max-width: 100%;
        max-height: 100%;
        padding: 10px;
        z-index: 2;
        position: relative;
    }

    .name {
        color: white;
        font-size: 20px;
        font-weight: 500;
        padding: 6px 15px 15px;
        width: 100%;
        line-height: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .stars img {
        width: 20px;
        height: 20px;
    }

    .stars .plus {
        width: 12px;
        height: 12px;
        margin-left: -2px;
    }

    .catalog :global(.pagination) {
        justify-content: center;
    }

    .rarity-id-0:before {
        background: linear-gradient(to bottom, #66DC96 , #0B0E21);
    }

    .rarity-id-1:before {
        background: linear-gradient(to bottom, #434ACF , #0B0E21);
    }

    .rarity-id-2:before {
        background: linear-gradient(to bottom, #B644D3 , #0B0E21);
    }

    .rarity-id-3:before {
        background: linear-gradient(to bottom, #FAC50E , #0B0E21);
    }

    .rarity-id-4:before {
        background: linear-gradient(to bottom, #CF4343 , #0B0E21);
    }

    .inventory-cards :global(.nft-card.disabled) {
        opacity: .7;
    }

    .inventory-cards :global(.nft-card:not(.disabled):hover) {
        transform: translateY(-4px);
        box-shadow: 0 8px 10px rgba(160, 174, 192, 0.2);
    }

    .elements img:nth-child(1) {
        position: relative;
        z-index: 5;
    }

    .elements img:nth-child(2) {
        position: relative;
        z-index: 4;
    }

    .elements img:nth-child(3) {
        position: relative;
        z-index: 3;
    }

    .elements img:nth-child(4) {
        position: relative;
        z-index: 2;
    }

    .elements img:nth-child(5) {
        position: relative;
        z-index: 1;
    }

    @media(max-width: 767px) {
        .dropdown {
            width: 100%;
            z-index: 4;
        }

        .sort-by-dropdown {
            z-index: 3;
            margin-top: 15px;
        }

        .sort-by {
            padding-top: 10px;
        }

        .need-select {
            padding: 14px 20px;
            height: 46px;
        }

        .inventory-cards {
            margin-top: 0;
            padding-top: 15px;
            margin-bottom: 5px;
        }

        .dropdown-list .checkbox,
        .dropdown-list .item {
            font-size: 14px;
            padding: 4px 0;
            margin-bottom: 8px;
        }

        .inventory-cards :global(.nft-card) {
            width: 100%;
            max-width: 400px;
            margin: 0 auto 20px;
        }

        .inventory-cards :global(.nft-card:hover) {
            transform: none;
            box-shadow: none;
        }

        .image {
            height: calc(100vw - 42px);
            max-height: 388px;
        }

        .nft-box-img img {
            margin: 25px 0 0 -55px;
        }
    }
</style>
